import { useState } from 'react';

import { UiButton, UiInput } from '@shared/common/ui';
import { formatTrialDateRu, shiftIsoDate } from '@crm/utils/trialDate';

/**
 * Запрос даты пробного занятия перед сменой статуса (ТЗ «Дата пробного», §4, §5, §9).
 *
 * Компонент ничего не сохраняет сам: он отдаёт дату наверх, а карточка/колонка
 * меняются только после успешного ответа backend.
 */
export function TrialDateModal({
  title,
  subtitle,
  mode,
  currentDate,
  today,
  busy,
  error,
  submitLabel,
  onSubmit,
  onClose,
}) {
  const isReschedule = mode === 'reschedule_required';

  const [value, setValue] = useState(() => {
    const hasFuture = currentDate && currentDate >= today;
    if (isReschedule) return shiftIsoDate(hasFuture ? currentDate : today, 1);
    return hasFuture ? currentDate : today;
  });

  const sameAsCurrent = isReschedule && value === currentDate;

  return (
    <div className="modal-backdrop" onClick={busy ? undefined : onClose} role="presentation">
      <form
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="trial-date-modal-title"
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault();
          if (!value || sameAsCurrent) return;
          onSubmit(value);
        }}
      >
        <header className="modal-card__header">
          <h2 id="trial-date-modal-title">
            {title ?? (isReschedule ? 'Перенос пробного занятия' : 'Дата пробного занятия')}
          </h2>
          <UiButton
            variant="ghost"
            size="sm"
            type="button"
            onClick={onClose}
            disabled={busy}
            aria-label="Закрыть"
          >
            ×
          </UiButton>
        </header>

        <div className="modal-card__body" style={{ display: 'grid', gap: 12 }}>
          {subtitle && (
            <p className="muted" style={{ margin: 0 }}>
              {subtitle}
            </p>
          )}

          {isReschedule && (
            <p className="muted" style={{ margin: 0 }}>
              Текущая дата: {currentDate ? formatTrialDateRu(currentDate) : 'не назначена'}
            </p>
          )}

          <UiInput
            className="field"
            label={isReschedule ? 'Новая дата' : 'Дата пробного занятия'}
            type="date"
            min={today}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
          />

          {sameAsCurrent && (
            <div className="banner banner--danger">Новая дата должна отличаться от текущей</div>
          )}
          {error && <div className="banner banner--danger">{error}</div>}

          <div className="form-actions">
            <UiButton variant="ghost" type="button" onClick={onClose} disabled={busy}>
              Отмена
            </UiButton>
            <UiButton type="submit" disabled={busy || !value || sameAsCurrent}>
              {submitLabel ?? (isReschedule ? 'Перенести' : 'Сохранить')}
            </UiButton>
          </div>
        </div>
      </form>
    </div>
  );
}
